import React from 'react';

const SelectDiv = ({
  tabIndex,
  classes,
  onClick,
  children,
  aria,
  isDropDownOpen
}) => {
  const onKeyPress = e => {
    const enterOrSpace = e.key === 'Enter';
    if (enterOrSpace) {
      onClick();
    }
  };

  return (
    <div
      role="listbox"
      tabIndex={tabIndex}
      className={classes}
      onClick={onClick}
      onKeyPress={onKeyPress}
      {...aria}
      aria-expanded={isDropDownOpen}
    >
      {children}
    </div>
  );
};

export default SelectDiv;
